import React from 'react';
import { Link, useRouteMatch, useParams } from 'react-router-dom';
import { Aside } from '../../components/Layout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChartColumn } from '@fortawesome/free-solid-svg-icons'
import { faListAlt } from '@fortawesome/free-regular-svg-icons'

export const FlowDeviceAside = () => {
  const { path, url } = useRouteMatch();
  const { hydrantId } = useParams();
  const id = +hydrantId;

  return (
    <Aside>
      <Link to={`${url}/edit`} className='aside-item'>
        <div className="icon-button" title="Flow Device">
          <FontAwesomeIcon icon={faListAlt} />
        </div>
        <span>Flow Device</span>
      </Link>
      {/* <Link to={`${url}/flowChart`} className='aside-item'>
        <div className="icon-button" title="Flow Chart">
          <FontAwesomeIcon icon={faChartColumn} />
        </div>
        <span>Flow Chart</span>
      </Link> */}
    </Aside>
  );
};